// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//
import DatePicker from 'vue-bootstrap-datetimepicker'
// import 'bootstrap/dist/css/bootstrap.css'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

// import 'summernote/dist/summernote-bs4.css'
import 'bootstrap'
// import 'summernote'
//
import VueTrumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg'
import 'jquery-resizable-dom/dist/jquery-resizable.min'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import VueTransmit from 'vue-transmit'
import Toasted from 'vue-toasted'
import ToggleButton from 'vue-js-toggle-button'
import moment from 'vue-moment'
import VueTruncate from 'vue-truncate-filter'
import VueTheMask from 'vue-the-mask'
import VueProgressBar from 'vue-progressbar'
import axios from './services/axios'

function install (Vue) {
  /**
   * Plugins
   */
  Vue.use(VueTrumbowyg)
  Vue.use(VueAxios, axios)
  Vue.use(BootstrapVue)
  Vue.use(VueTransmit)
  Vue.use(ToggleButton)
  Vue.use(moment)
  Vue.use(VueTruncate)
  Vue.use(VueTheMask)
  Vue.use(Toasted, {
    iconPack: 'fontawesome',
    duration: 3000
  })
  Vue.use(DatePicker)
  Vue.use(VueProgressBar, {
    color: '#5a6779',
    failedColor: 'red',
    height: '5px'
  })
}

export default install

export const datepickerOptions = {
  viewMode: 'days',
  format: 'DD/MM/YYYY HH:mm',
  extraFormats: ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD'],
  useCurrent: true,
  inline: false,
  // showTodayButton: true,
  icons: {
    time: 'fa fa-clock-o',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-left',
    next: 'fa fa-chevron-right',
    today: 'fa fa-dot-circle-o',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
  }
}

export const slugifyOptions = {
  replacement: '-',
  remove: /[^a-zA-Z\d\s:-]/,
  lower: true
}



// WEBPACK FOOTER //
// ./src/plugins.js